<template>
    <div v-cloak>
        <h1>Welcome to HKIA GIS Engineering Systems</h1>
        <b-container>
            <b-card-group >
                <b-button
                    variant="success"
                    class="sub-system"
                    :href="portalEGIS"
                    target="_blank">
                    <b-card overlay title="Enterprise Basemap"
                        img-src="@/assets/basemap.jpg"
                        img-alt="Image"
                        img-top
                        tag="article"
                        style="max-width: 20rem;"
                        class="mb-2">
                    </b-card>
                </b-button>
                <b-button
                    variant="success"
                    class="sub-system"
                    :disabled='!ENABLED_SYSTEMS.APS'
                    :to="{ path: '/airfield-pavement-area/welcome' }" >
                    <b-card overlay title="Airfield Pavement System"
                        img-src="@/assets/Resurfacing-h-200.png"
                        img-alt="Image"
                        img-top
                        tag="article"
                        style="max-width: 20rem;"
                        class="mb-2">
                        <span v-show='!ENABLED_SYSTEMS.APS'>Under Development</span>
                    </b-card>
                </b-button>
            <!-- </b-card-group>
            <b-card-group > -->
                <b-button
                variant="success"
                class="sub-system"
                :disabled='!ENABLED_SYSTEMS.POT'
                :to="{ path: '/potable-water-area' }" >
                    <b-card overlay title="Potable Water Supply System"
                        img-src="@/assets/IMG-Potable_water_System_400_300.jpg"
                        img-alt="Image"
                        img-top
                        tag="article"
                        style="max-width: 20rem;"
                        class="mb-2">
                        <span v-show='!ENABLED_SYSTEMS.POT'>Under Development</span>
                    </b-card>
                </b-button>

                <b-button
                variant="success"
                class="sub-system"
                :disabled='!ENABLED_SYSTEMS.HML'
                :to="{ path: '/high-mast-lighting-area' }" >
                    <b-card overlay title="High Mast Lighting System"
                        img-src="@/assets/HighMastLight.jpg"
                        img-alt="Image"
                        img-top
                        tag="article"
                        style="max-width: 20rem;"
                        class="mb-2">
                        <span v-show='!ENABLED_SYSTEMS.HML'>Under Development</span>
                    </b-card>
                </b-button>
                <b-button
                variant="success"
                class="sub-system"
                :disabled='!ENABLED_SYSTEMS.AGL'
                :to="{ path: '/airfield-ground-light-area'  }" >
                    <b-card overlay title="Airfield Ground Lighting System"
                        img-src="@/assets/AGL.jpg"
                        img-alt="Image"
                        img-top
                        tag="article"
                        style="max-width: 20rem;"
                        class="mb-2">
                        <span v-show='!ENABLED_SYSTEMS.AGL'>Under Development</span>
                    </b-card>
                </b-button>
                <b-button
                variant="success"
                class="sub-system"
                :disabled='!ENABLED_SYSTEMS.SEWER'
                :to="{ path: '/sewer-area' }" >
                    <b-card overlay title="Sewerage System"
                        img-src="@/assets/IMG-Sewerage System_400_300.jpg"
                        img-alt="Image"
                        img-top
                        tag="article"
                        style="max-width: 20rem;"
                        class="mb-2">
                        <span v-show='!ENABLED_SYSTEMS.SEWER'>Under Development</span>
                    </b-card>
                </b-button>
            </b-card-group>
        </b-container>
    </div>

</template>
<script>
  export default {
    data() {
      return {
        ENABLED_SYSTEMS: process.env.__ENABLED_SYSTEMS__,
        portalEGIS:process.env.__PORTAL_EGIS__,
        isAgisAdmin: true
      };
    },
  };
</script>
<style scoped>
[v-cloak] {
  display: none;
}
*,
*::before,
*::after {
  box-sizing: border-box;
  min-height: 0.01px;
}

.btn.sub-system{
    white-space:normal;
    background-color:#258dc8 ;
    border-color: #258dc8 ;
}
.btn.sub-system:hover {
    background-color:#258dc8 ;
    border-color: #258dc8 ;
}
.system-admin{
    color: black
}
.test{
    display: inline;
}
</style>



// WEBPACK FOOTER //
// src/components/home/Home.vue